import RequestService from './RequestService';
import axios from 'axios';

export default class RequestInitializer
{
  static get(number)
  {
    return new Array(number).fill(true).map(() => {
      let source = axios.CancelToken.source();      
      return {
        source,
        get: async (url, params = {}, config = {}) => {
          const result = await RequestService.get(url, params, { ...config,  cancelToken: source.token })
          return result;
        }
      }
    })
  }
}